export class SendCommitterCommandRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "command",
            "baseName": "command",
            "type": "CommitterCommand",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SendCommitterCommandRequest.attributeTypeMap;
    }
    constructor() {
    }
}
